/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from 'react'
import { Autosuggest, InputLabel as Label } from '..'
import { FindQuery } from '@sentecacommerce-theme/lib'

export const DeliveryAutosuggest = ({
  getItems,
  remove,
  setItem,
  label,
  items,
  disabled,
  selected,
  parent,
  minLength = 3,
}: DeliveryAutosuggestProps) => {
  const [isFetching, setIsFetching] = useState(false)

  const fetchItems = useCallback(
    async (query: string) => {
      setIsFetching(true)

      const searchQuery: FindQuery = {
        text: query,
      }

      if (parent) searchQuery.parent = parent

      await getItems(searchQuery)

      setIsFetching(false)
    },
    [parent]
  )

  const onChange = async (value: any) => {
    setItem(value.data)
  }

  const getOptions = () => {
    if (Array.isArray(items)) return items

    if (Array.isArray(items?.data)) return items.data

    return []
  }

  const formattedSelectedType = formatType(selected?.type)

  const formattedSelectedName = formatName(selected?.name)

  const selectedLabel = `${formattedSelectedType} ${formattedSelectedName}`.trim()

  const onRemove = async () => {
    await remove()
  }

  return (
    <Label isDisabled={disabled}>
      {label}
      <Autosuggest
        options={getOptions()}
        getValue={(option: any) => option.id}
        getLabel={(option: any) => {
          const name = formatName(option.data.name)
          const type = formatType(option.data.type)

          return `${type} ${name}`.trim()
        }}
        withRemoveIconWhenSelected
        onRemove={onRemove}
        isFetching={isFetching}
        onOptionSelect={onChange}
        updateOptions={fetchItems}
        selectedOption={selectedLabel}
        disabled={disabled}
        minLength={minLength}
      />
    </Label>
  )
}

function formatType(str?: string) {
  if (!str) return ''

  return str.toLowerCase().replace('office', 'офис').replace('apt', 'авт.')
}

function formatName(str?: string) {
  if (!str) return ''
  return str
    .toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0)?.toUpperCase() + s.slice(1))
    .join(' ')
}

type DeliveryAutosuggestProps = {
  getItems: (data: FindQuery) => void
  setItem: any
  remove: any
  label: string
  items: any
  selected?: any
  disabled?: boolean
  parent?: any
  minLength?: number
}
